// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var { isUndefined } = require('lodash/fp');
  var m = require('mobx');
  var trackable = require('share/tracking/Izenda.Trackable');
  var constants = require('logic/data/Izenda.TenantConstants');
  var PermissionDetail = require('./Izenda.PermissionDetail');
  var PermissionAccess = require('./Izenda.Access');

  function TenantDetail(details) {
    details = details || {};

    m.extendObservable(trackable(this), {
      id: null,
      tenantID: '',
      name: '',
      description: '',
      active: null,
      deleted: null,
      tenantModules: [],
      isSelected: false,
      permission: null,

      hasDirty: function() {
        return this.isDirty || this.permission.isDirty || this.permissionAccessModel.checkDirty();
      },
      displayName: function() {
        return String.format('{0} - {1}', this.tenantID, this.name);
      },
      version: 0,
      created: null,
      createdBy: null,
      modified: null,
      modifiedBy: null,
      isNew: function() {
        return !String.isGuidFormat(this.id);
      }
    });
    this.permissionAccessModel = new PermissionAccess();
    this.populateData(details);
  }

  TenantDetail.constraints = {
    tenantID: constants.TENANT_ID_CONSTRAINT,
    name: constants.TENANT_NAME_CONSTRAINT
  };

  /**
   * populate data
   * @param  {object} details
   */
  TenantDetail.prototype.populateData = m.action(function(details) {
    this.id = details.id;
    this.tenantID = details.tenantID;
    this.name = details.name;
    this.description = details.description;
    this.active = isUndefined(details.active) ? true : details.active;
    this.deleted = details.deleted;
    this.tenantModules = details.tenantModules;
    this.permission = new PermissionDetail(details.permission, true);
    this.version = details.version || 0;
    this.created = details.created;
    this.createdBy = details.createdBy;
    this.modified = details.modified;
    this.modifiedBy = details.modifiedBy;
  });

  /**
   * set data by key
   * @param {string} key
   */
  TenantDetail.prototype.setDataByKey = function(key, value) {
    this[key] = value;
    this.markDirty();
  };

  /**
   * update selected modules
   * @param  {object}  module
   * @param  {Boolean} isAdd
   */
  TenantDetail.prototype.updateModules = function(module, isAdd) {
    var tenantModules = (this.tenantModules = this.tenantModules || []);

    this.markDirty();
    if (isAdd) {
      return !this.hasModule(module) && tenantModules.push(module.name);
    } else {
      var moduleIndex = tenantModules.indexOf(module.name);
      return moduleIndex > -1 && tenantModules.splice(moduleIndex, 1);
    }
  };

  /**
   * check the tenant detail has module
   * @param  {[Object]} module
   * @return {boolean}
   */
  TenantDetail.prototype.hasModule = function(module) {
    return this.tenantModules && this.tenantModules.indexOf(module.name) > -1;
  };

  /**
   * set the tenant selected
   * @param {boolean} newValue
   */
  TenantDetail.prototype.setSelected = function(newValue) {
    return (this.isSelected = newValue);
  };

  /**
   * set tenant detail active
   * @param {boolean} newValue
   */
  TenantDetail.prototype.setActive = function(newValue) {
    return (this.active = newValue);
  };

  /**
   * Update permission
   * @param {Object} permission
   */
  TenantDetail.prototype.updatePermission = function(permission) {
    this.permission = permission;
  };

  /**
   * Clean model dirty
   */
  TenantDetail.prototype.cleanDirty = function() {
    this.resetDirty();
    this.permission.cleanDirty();
    this.permissionAccessModel.cleanDirty();
  };

  /**
   * Update tenant version after save
   */
  TenantDetail.prototype.updateVersion = function() {
    this.version++;
  };

  module.exports = TenantDetail;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.TenantDetails.js